import {useContext} from "react";
import {PassingTestContext} from "./passingTestContext";

export default function PassingTestHeader() {
  const {answersResult, showResultsTest, percentResultTest} = useContext(PassingTestContext);

  return (
    <header className="flex justify-between shrink-0 mb-8 items-center">
      <h1 className="text-[#111928]">Тестирование</h1>
      {!!Object.keys(answersResult).length && showResultsTest ? <span className="text-[18px] text-[#22AD5C] font-medium">{percentResultTest}%</span> : null}
    </header>
  );
}
